/*
  TEMPORARY DIAGNOSTIC -- remove once the mobile nav mis-tap is resolved.

  Investigating: tapping a brand in the mobile menu drawer navigates to a brand a few rows
  earlier in the list. Reproduces on the client's iPhone 12 Pro Max / iOS 18.6, but not on
  ours or on a simulator of the same device, so this collects evidence from the real device.

  Inert unless enabled. Turn on with ?kcdebug=1 (sticks for the session), off with ?kcdebug=0.

  It records what sits under the finger at touchstart versus what the browser actually
  activates at click, plus every value that could move the list in between. On a mismatch it
  BLOCKS the navigation and freezes a red report on screen, so the evidence can be
  screenshotted rather than caught in a single video frame.
*/
(function () {
  'use strict';

  var KEY = 'kcdebug';
  var enabled = false;
  try {
    if (/[?&]kcdebug=0/.test(location.search)) {
      localStorage.removeItem(KEY);
      return;
    }
    if (/[?&]kcdebug=1/.test(location.search)) {
      localStorage.setItem(KEY, '1');
      enabled = true;
    } else {
      enabled = localStorage.getItem(KEY) === '1';
    }
  } catch (e) {
    enabled = /[?&]kcdebug=1/.test(location.search);
  }
  if (!enabled) return;

  var lines = [];
  var frozen = false;
  var t0 = performance.now();

  /* ---------- overlay: fixed + pointer-events:none so it cannot alter hit-testing ---------- */
  var box = document.createElement('div');
  box.style.cssText = [
    'position:fixed', 'top:0', 'left:0', 'right:0', 'z-index:2147483647',
    'pointer-events:none', 'font:10px/1.35 ui-monospace,Menlo,monospace',
    'background:rgba(0,0,0,.82)', 'color:#0f0', 'padding:4px 6px',
    'white-space:pre-wrap', 'word-break:break-word', 'max-height:46vh', 'overflow:hidden',
  ].join(';');

  var report = document.createElement('div');
  report.style.cssText = [
    'position:fixed', 'top:0', 'left:0', 'right:0', 'bottom:0', 'z-index:2147483647',
    'pointer-events:none', 'display:none', 'font:12px/1.45 ui-monospace,Menlo,monospace',
    'background:rgba(120,0,0,.94)', 'color:#fff', 'padding:14px', 'white-space:pre-wrap',
    'overflow:auto',
  ].join(';');

  function mount() {
    if (document.body) {
      document.body.appendChild(box);
      document.body.appendChild(report);
    }
  }
  if (document.body) mount();
  else document.addEventListener('DOMContentLoaded', mount);

  /* ---------- measurement ---------- */
  function panelEl() {
    return document.querySelector('.kinder-drawer__subpanel.is-active');
  }

  function snap() {
    var cs = getComputedStyle(document.documentElement);
    var header = document.querySelector('.section-header');
    var drawer = document.querySelector('#menu-drawer');
    var p = panelEl();
    var vv = window.visualViewport;
    var d = drawer ? drawer.getBoundingClientRect() : null;
    return {
      hb: cs.getPropertyValue('--header-bottom-position').trim(),
      vh: cs.getPropertyValue('--viewport-height').trim(),
      ih: window.innerHeight,
      vvH: vv ? Math.round(vv.height) : null,
      vvTop: vv ? Math.round(vv.offsetTop) : null,
      vvScale: vv ? +vv.scale.toFixed(3) : null,
      hdrB: header ? +header.getBoundingClientRect().bottom.toFixed(1) : null,
      hdrHidden: header ? header.classList.contains('shopify-section-header-hidden') : null,
      menuOpen: header ? header.classList.contains('menu-open') : null,
      dTop: d ? Math.round(d.top) : null,
      dBot: d ? Math.round(d.bottom) : null,
      pClient: p ? p.clientHeight : null,
      pScrollH: p ? p.scrollHeight : null,
      pScroll: p ? Math.round(p.scrollTop) : null,
      docY: Math.round(window.scrollY),
    };
  }

  function fmt(s) {
    return (
      'hb=' + s.hb + ' vh=' + s.vh + ' ih=' + s.ih +
      ' | vv=' + s.vvH + '@' + s.vvTop + 'x' + s.vvScale +
      ' | hdr=' + s.hdrB + (s.hdrHidden ? ' HIDDEN' : '') + (s.menuOpen ? ' OPEN' : '') +
      ' | drw=' + s.dTop + '-' + s.dBot +
      ' | pan c=' + s.pClient + ' sh=' + s.pScrollH + ' st=' + s.pScroll +
      ' | docY=' + s.docY
    );
  }

  function linkAt(x, y) {
    var el = document.elementFromPoint(x, y);
    if (!el) return null;
    return el.closest ? el.closest('a') || el : el;
  }

  function label(el) {
    if (!el) return '(none)';
    return (el.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 32) || '(blank)';
  }

  var dirty = false;
  function log(ev, extra) {
    if (frozen) return;
    var s = snap();
    lines.push('[' + Math.round(performance.now() - t0) + '] ' + ev + (extra ? ' ' + extra : '') + '\n    ' + fmt(s));
    if (lines.length > 9) lines.shift();
    dirty = true;
    return s;
  }

  function render() {
    if (dirty && !frozen) {
      dirty = false;
      var build = window.__kcBuild;
      box.textContent =
        'BUILD: ' + (build || '*** MISSING -- STALE CACHED JS ***') + '\n' + lines.join('\n');
      box.style.color = build ? '#0f0' : '#ff5252';
    }
    requestAnimationFrame(render);
  }
  requestAnimationFrame(render);

  /* ---------- passive environment events ---------- */
  addEventListener('resize', function () { log('resize'); }, true);
  addEventListener('orientationchange', function () { log('orientationchange'); }, true);
  if (window.visualViewport) {
    visualViewport.addEventListener('resize', function () { log('vv:resize'); });
    visualViewport.addEventListener('scroll', function () { log('vv:scroll'); });
  }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('kinder-drawer__subpanel')) log('panel:scroll');
  }, true);

  /* ---------- the decisive measurement ---------- */
  var start = null;

  document.addEventListener('touchstart', function (e) {
    var t = e.touches[0];
    var el = linkAt(t.clientX, t.clientY);
    start = {
      x: t.clientX,
      y: t.clientY,
      el: el,
      elTop: el ? el.getBoundingClientRect().top : null,
      snap: snap(),
    };
    log('TOUCHSTART y=' + Math.round(t.clientY), '-> ' + label(el));
  }, true);

  document.addEventListener('touchend', function (e) {
    var t = e.changedTouches[0];
    log('touchend y=' + Math.round(t.clientY), '-> ' + label(linkAt(t.clientX, t.clientY)));
  }, true);

  document.addEventListener('click', function (e) {
    if (!start) return;
    var activated = e.target && e.target.closest ? e.target.closest('a') : null;
    var nowAtFinger = linkAt(start.x, start.y);
    var shift =
      start.el && start.elTop !== null
        ? Math.round(start.el.getBoundingClientRect().top - start.elTop)
        : null;

    log('CLICK', '-> ' + label(activated) + ' | shift=' + shift + 'px');

    var mismatch = !!(start.el && activated && activated !== start.el);
    if (!mismatch) {
      persist();
      return;
    }

    // Freeze the evidence rather than navigating away from it.
    e.preventDefault();
    e.stopPropagation();
    frozen = true;

    var after = snap();
    var b = start.snap;
    var changed = [];
    ['hb', 'vh', 'ih', 'vvH', 'vvTop', 'vvScale', 'hdrB', 'dTop', 'dBot', 'pClient', 'pScrollH', 'pScroll', 'docY']
      .forEach(function (k) {
        if (String(b[k]) !== String(after[k])) changed.push(k + ': ' + b[k] + ' -> ' + after[k]);
      });

    report.textContent =
      'MISMATCH -- navigation blocked\n\n' +
      'BUILD: ' + (window.__kcBuild || '*** MISSING -- STALE CACHED JS ***') + '\n\n' +
      'Finger was on : ' + label(start.el) + '\n' +
      'Would open    : ' + label(activated) + '\n' +
      'Href          : ' + (activated.getAttribute('href') || '?') + '\n' +
      'Now at finger : ' + label(nowAtFinger) + '\n' +
      'List moved    : ' + shift + 'px\n\n' +
      'CHANGED BETWEEN TOUCH AND TAP:\n' +
      (changed.length ? changed.join('\n') : '(nothing changed -- not a layout shift)') +
      '\n\nbefore: ' + fmt(b) + '\nafter : ' + fmt(after) +
      '\n\nRECENT:\n' + lines.join('\n') +
      '\n\nScreenshot this and send it over. Reload to run again.';
    report.style.display = 'block';
    persist();
  }, true);

  function persist() {
    try {
      sessionStorage.setItem('kcdebug:last', JSON.stringify({ build: window.__kcBuild || null, lines: lines }));
    } catch (e) {}
  }

  log('debug ready');
})();
